import React from 'react';
import { Link } from 'react-router-dom';

const PublicHeader = () => {
  return (
    <header
      className="text-white shadow-xl backdrop-blur-sm sticky top-0 z-40"
      style={{
        backgroundColor: '#3A3A3A'
      }}
    >
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center space-x-2">
            <Link to="/" className="relative group">
              <div className="absolute inset-0 bg-white/20 rounded-lg blur opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              <img
                src="/justpractice_yellow.png"
                alt="JustPractice"
                className="h-10 w-auto relative z-10 transition-transform duration-300 group-hover:scale-105 cursor-pointer"
              />
            </Link>
          </div>

          <div className="flex items-center space-x-4">
            <Link
              to="/pricing"
              className="text-sm text-gray-200 hover:text-white transition-colors duration-200 font-medium"
            >
              Pricing
            </Link>
            <Link
              to="/privacy-policy"
              className="text-sm text-gray-200 hover:text-white transition-colors duration-200 font-medium"
            >
              Privacy Policy
            </Link>
            <Link
              to="/terms-of-service"
              className="text-sm text-gray-200 hover:text-white transition-colors duration-200 font-medium"
            >
              Terms of Service
            </Link>
            <Link
              to="/login"
              className="text-sm px-4 py-2 rounded-lg bg-white/20 text-white hover:bg-white/30 transition-all duration-200 font-medium"
            >
              Login
            </Link>
          </div>
        </div>
      </div>
    </header>
  );
};

export default PublicHeader;
